<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >PROMOÇÕES DESTAQUES</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn @click="novo()" 
          v-show="$can('admin.loja|promocao.create')" color="topEnviados" dark>
            <v-icon>mdi-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsPromocao"
        :loading="loading_table"
        :items-per-page="25"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        :footerProps="footerProps"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template v-slot:item.action="{ item }">
          <v-icon
            color="error"
            class="mr-2"
            v-show="$can('admin.loja|promocao.delete')"
            @click="deletePromocao(item)"
            >delete</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text>Deseja excluir essa promoção?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialogCadastro" max-width="80%">
      <v-card>
        <v-card-title class>
          <span v-if="cadastro">Cadastrar Promoção</span>
          <span v-if="cadastro == false">Editar Promoção</span>
        </v-card-title>
        <v-card-text>
          
          <v-form ref="form">
            <v-row>
              <v-col cols="12" xl="4" lg="4" md="6" sm="8" xs="12">
                <v-select
                  v-model="promocao.id_produto"
                  :items="itemsProduto"
                  label="Produto"
                  :item-text="item=>`${item.descricao_reduzida} - preço: ${item.preco}`"
                  item-value="id"                  
                
                  clearable
                  dense
                  filled
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  prepend-inner-icon="monetization_on"
                  filled
                  v-model="promocao.valor"
                  v-currency="{
                    currency: null,
                    locale: 'pt-PT',
                    precision: 2,
                  }"
                  dense
                  clearable
                  label="Valor"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" xl="4" lg="4" md="4" sm="8" xs="12">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="140"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateIniFormatted"
                      label="Data Inicial"
                      readonly
                      v-on="on"
                      filled
                      dense
                      clearable
                      color="info"
                      header-color="primary"
                      persistent-hint
                      prepend-inner-icon="date_range"
                      @blur="
                        promocao.data_inicial = parseDate(dateIniFormatted)
                      "
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    locale="pt-br"
                    v-model="promocao.data_inicial"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" xl="4" lg="4" md="4" sm="8" xs="12">
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      slot="activator"
                      v-model="dateFimFormatted"
                      label="Data Final"
                      color="info"
                      header-color="primary"
                      persistent-hint
                      filled
                      dense
                      v-on="on"
                      clearable
                      prepend-inner-icon="event"
                      @blur="promocao.data_final = parseDate(dateFimFormatted)"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="pt-br"
                    v-model="promocao.data_final"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="6" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6" md="6" lg="6">
            <v-btn
              v-if="cadastro"
              color="success"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :timeout="tempo"
      :color="error"
      :multi-line="multiline"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
      text
    >
      {{ textSnack }}
      <v-btn @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>

    <v-snackbar
      :timeout="2000"
      :color="sucesso"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
      text
    >
      {{ textSucesso }}
      <v-btn @click.native="snackbarSuccess = false">Fechar</v-btn>
    </v-snackbar>
  </v-content>
</template>

<script>
import { mask } from "vue-the-mask";
var moment = require("moment");
export default {
  directives: { mask },
  props: {
    source: String,
  },
  data: (vm) => ({
    footerProps: { "items-per-page-options": [30, 50, 100] },
    cadastro: true,

    error: "error",
    tempo: 2000,
    mode: "vertical",

    sucesso: "botao_sucesso",
    snackbarSuccess: false,
    snackbar: false,
    textSucesso: "",
    textSnack: "",
    multiline: true,
    dialogCancel: false,
    selItem: "",
    singleLine: true,
    promocao: {
      id: "",
      id_produto: "",
      data_inicial: new Date().toISOString().substr(0, 10),
      data_final: moment()
        .add(5, "days")
        .format("YYYY-MM-DD"),
      valor: "",
    },
    itemsProduto: [],
    itemsUnidade: ["UN"],

    filtroProduto: "Produtos ",
    sv: false,
    dialogCadastro: false,
    dialogCadastroEditar: false,
    itensPorPagina: 25,
    itemsPromocao: [],
    itemsProdutos: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selPromocao: "",
    itemEdit: "",
    //date_fim: new Date().toISOString().substr(0, 10),
    //date_ini: moment().format("YYYY-MM-01"),
    dateFimFormatted: moment()
      .add(5, "days")
      .format("DD/MM/YYYY"),
    dateIniFormatted: moment().format("DD/MM/YYYY"),

    menu: false,
    menu2: false,
    dialogVinc: false,
    imageFile: "",
    headers: [
      {
        text: "Código",
        align: "left",
        value: "codigo",
      },
      {
        text: "Produto",
        value: "descricao_reduzida",
        sortable: true,
        align: "left",
      },
      {
        text: "Categoria",
        value: "categoria",
        sortable: true,
        align: "left",
      },
      {
        text: "Data início",
        value: "data_inicial",
        align: "left",
      },
      {
        text: "Data final",
        value: "data_final",
        align: "left",
      },
       
      {
        text: "Preço",
        value: "preco",
        align: "right",
      },
      {
        text: "Valor",
        value: "valor",
        align: "right",
      },

      { text: "Excluir", value: "action", sortable: false },
    ],
  }),

  watch: {
    "promocao.data_inicial"(val) {
      this.dateIniFormatted = this.formatDate(this.promocao.data_inicial);
    },
    "promocao.data_final"(val) {
      this.dateFimFormatted = this.formatDate(this.promocao.data_final);
    },
  },
  mounted() {
    //this.buscaProdutos();
    //this.buscaProdutos();
    this.produtos();
    this.buscaPromocao();
    // this.produto.unidade = "UN";
  },
  methods: {
    mostraValorAtual(item){
      console.log(item)
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    tamanhoReduzida(ev) {
      if (ev.target.value.length === 35) {
        event.preventDefault();
        return;
      }
    },
    tamanhoDescricao(ev) {
      if (ev.target.value.length === 40) {
        event.preventDefault();
        return;
      }
    },
    mudarStatus(id, status) {
      axios
        .post(`/adm/produto/status`, { id: id, status: status })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Status alterado!";
            this.buscaPromocao();
          }
        });
    },
    checkStatus(valor) {
      if (valor) {
        return "Ativa";
      } else {
        return "Desativada";
      }
    },
    novo() {
      this.cadastro = true;
      this.dialogCadastro = true;
      this.promocao.id = "";
      (this.promocao.id_produto = ""), (this.promocao.valor = "");
    },

    editPromocao(item) {
      this.cadastro = false;
      this.dialogCadastro = true;
      //this.itemEdit = item.id;

      this.promocao.id = item.id;
      this.promocao.id_produto = item.id_produto;
      this.promocao.valor = item.valor;

      // this.buscaImgProduto(this.produto.id);
    },
    buscaImgProduto(id) {
      axios.get(`/produto/img/` + id).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          if (response.data !== "") {
            this.produto.img = response.data;
          } else {
            this.produto.img =
              "https://via.placeholder.com/110x110.png?text=Sem imagem";
          }
        }
      });
    },
    produtos() {
      axios.get(`/produto/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.itemsProduto = response.data;
        }
      });
    },
    gravarEdicao() {
      //console.log(this.file);

      var formData = new FormData();

      formData.append("produto", JSON.stringify(this.produto));
      // formData.append("file", document.getElementById("avatar"));

      axios
        .post(`/produto/editar`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.itemEdit = "";
            this.selPromocao = "";
            this.snackbarSuccess = true;
            this.textSucesso = "Produto alterado com sucesso!";
            this.dialogCadastro = false;
            this.buscaProdutos();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    gravar() {
      var formData = new FormData();

      // var imagefile = document.querySelector("#avatar");
      //formData.append("image", imagefile.files[0]);
      // formData.append("image", this.imageFile);
      formData.append("promocao", JSON.stringify(this.promocao));
      // formData.append("file", document.getElementById("avatar"));

      axios
        .post(
          `adm/promocao`,

          formData
        )
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.itemEdit = "";
            this.selPromocao = "";
            this.snackbarSuccess = true;
            this.dialogCadastro = false;
            this.textSucesso = "Promoção incluida com sucesso!";
            this.buscaPromocao();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    deletePromocao(item) {
      console.log(item);
      this.selItem = item.id;

      this.dialogCancel = true;
    },
    deleta() {
      axios
        .post(`/adm/promocao/deleta`, { id: this.selItem })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbarError = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.dialogCancel = false;
            this.buscaPromocao();
          }
        });
    },
    buscaPromocao() {
      this.loading_table = true;
      axios.get(`adm/promocao`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsPromocao = response.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
.v-input__slot {
  margin-bottom: 0px !important;
}
.v-messages {
  min-height: 0px !important;
}
</style>
